import { cellRefText, sheetRefPrefix, type Token, tokenize } from "@package/scratchpad-utils";

const MAX_COL = 16384;
const MAX_ROW = 1_048_576;

function shiftedRefText(t: Token & { kind: "ref" }, dCol: number, dRow: number): string {
  const { start, end } = t.addr;
  const cells = end ? [start, end] : [start];
  const moved = cells.map((c) => ({
    ...c,
    col: c.colAbs ? c.col : c.col + dCol,
    row: c.rowAbs ? c.row : c.row + dRow,
  }));
  if (moved.some((c) => c.col < 0 || c.col >= MAX_COL || c.row < 0 || c.row >= MAX_ROW)) return "#REF!";
  const sheet = start.sheet ? sheetRefPrefix(start.sheet) : "";
  const [first, second] = moved;
  return `${sheet}${cellRefText(first!)}${second ? `:${cellRefText(second)}` : ""}`;
}

export function shiftRefs(src: string, dCol: number, dRow: number): string {
  if (!src.startsWith("=")) return src;
  let tokens: Token[];
  try {
    tokens = tokenize(src.slice(1));
  } catch {
    return src;
  }
  let out = src;
  for (let i = tokens.length - 1; i >= 0; i--) {
    const t = tokens[i]!;
    if (t.kind !== "ref") continue;
    out = out.slice(0, t.span.start + 1) + shiftedRefText(t, dCol, dRow) + out.slice(t.span.end + 1);
  }
  return out;
}
